// TokenRefreshQueue.ts (예시 파일명)

type Resolver = (token: string) => void;
type Rejecter = (err: unknown) => void;
type QueueItem = { resolve: Resolver; reject: Rejecter };

class TokenRefreshQueueManager {
  private isRefreshing = false;
  private requestQueue: QueueItem[] = [];

  // --- 1. 기존과 동일한 인터페이스 제공 ---

  public getIsRefreshing(): boolean {
    return this.isRefreshing;
  }

  public setIsRefreshing(v: boolean): void {
    this.isRefreshing = v;
  }

  public enqueueRequest(resolve: Resolver, reject: Rejecter): void {
    this.requestQueue.push({ resolve, reject });
  }

  public resolveQueue(token: string): void {
    // splice(0)는 배열을 비우고, 비워진 요소들을 반환합니다. (안전한 방식)
    this.requestQueue.splice(0).forEach(({ resolve }) => resolve(token));
  }

  public rejectQueue(error: unknown): void {
    this.requestQueue.splice(0).forEach(({ reject }) => reject(error));
  }

  public processQueue(error: unknown | null, token: string | null = null): void {
    const queueToProcess = this.requestQueue.splice(0);

    if (error) {
      queueToProcess.forEach(({ reject }) => reject(error));
    } else if (token) {
      queueToProcess.forEach(({ resolve }) => resolve(token));
    }
  }
}

// --- 클래스의 싱글톤 인스턴스를 export ---
export const tokenRefreshQueue = new TokenRefreshQueueManager();